module.exports = __webpack_public_path__ + "media/images/squared-1-eb38a8c608514724ab8030824150df45.png";